import React, {useEffect, useRef, useState} from 'react';
import axios from "axios";
import {toast} from "react-toastify";
import AlertMessages from "../../../../components/messages/alert-message.js";
import projectUtils from "../../../../utils/project-utils.js";
import myUserService from "../../../../services/web/my-user-service.js";
import {Card} from "../../../../components/card/card.jsx";
import {FaArrowLeft, FaEye, FaEyeSlash} from "react-icons/fa";
import Button from "../../../../components/button/button.jsx";

const length = 4
const MyUserPin = ({refetch, setTarget, setIsLoading}) => {
    const [values, setValues] = useState(Array(length).fill(""));
    const [showPin, setShowPin] = useState(false);
    const [pin, setPin] = useState("")
    const inputsRef = useRef([]);

    const handleChange = (value, index) => {
        if (!/^\d?$/.test(value)) return;

        const newValues = [...values];
        newValues[index] = value;
        setValues(newValues);
        setPin(newValues.join(""))

        if (value && index < length - 1) {
            inputsRef.current[index + 1].focus();
        }
    }

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace" && !values[index] && index > 0) {
            inputsRef.current[index - 1].focus();
        }
    }

    const submit = () => {
        setIsLoading(true);

        const formData = new FormData();
        formData.append("pin", pin)

        myUserService.updatePin(formData)
            .then(() => {
                toast.success("Salvo com sucesso");
                setTarget("info");
                refetch();
            })
            .catch(error => {
                console.error(error);

                const {message} = error.response.data;

                let errMessage = AlertMessages[message] ?? "Não foi possível prosseguir.";
                projectUtils.swalErrorMessage("", errMessage, "Ok");
            })
            .finally(() => setIsLoading(false))
    }

    return (
        <>
            <Card>
                <Card.Body>
                    <h3 className="flex gap-2 items-center">
                        <FaArrowLeft className="cursor-pointer font-normal" onClick={() => setTarget("info")}/>
                        Alterar PIN
                    </h3>

                    <div className="p-3 grid grid-cols-12 gap-3">
                        <div className="flex flex-col">
                            <p className={"font-bold mb-1"}>PIN</p>
                            <div className="flex gap-3">
                                {values.map((value, index) => (
                                    <input
                                        key={index}
                                        ref={(el) => (inputsRef.current[index] = el)}
                                        type={showPin ? "text" : "password"}
                                        inputMode="numeric"
                                        maxLength={1}
                                        value={value}
                                        onChange={(e) => handleChange(e.target.value, index)}
                                        onKeyDown={(e) => handleKeyDown(e, index)}
                                        className="w-10 h-10 text-center text-xl font-semibold border border-[#e5e7eb] rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    />
                                ))}

                                <span className={"content-center text-xl cursor-pointer"} onClick={() => setShowPin(!showPin)}>
                                    {showPin ? <FaEye/> : <FaEyeSlash/>}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="flex justify-end p-[15px]">
                        <Button onClick={submit} actionFeedbackType='save'>

                            Salvar
                        </Button>
                    </div>
                </Card.Body>
            </Card>
        </>
    );
};

export default MyUserPin;